export const currentTimeZoneInMinutes = new Date().getTimezoneOffset() * -1;
